import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from '../lib/getSettingPageMeta'

const DetailsRootPage = React.lazy(() => import('modules/settings/pages/DetailsRootPage'))
const CreatePage = React.lazy(() => import('modules/settings/pages/CreatePage'))
const RemovePage = React.lazy(() => import('modules/settings/pages/RemovePage'))

const detailsSettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.details.path,
      element: <DetailsRootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'company_details'),
      },
      children: [
        {
          path: navigation.settings.details.newLegalEntity.path,
          element: <CreatePage />,
        },
        {
          path: navigation.settings.details.removeLegalEntityId.path,
          element: <RemovePage />,
        },
      ],
    },
  ]
}

export default detailsSettingsRoutes
